import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//新闻列表
export function newsListApi(_x) {
  return _newsListApi.apply(this, arguments);
}
function _newsListApi() {
  _newsListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(page) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", usePost('/web/studyLists', page));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _newsListApi.apply(this, arguments);
}
export function newsApi(_x2) {
  return _newsApi.apply(this, arguments);
}
//热门新闻
function _newsApi() {
  _newsApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", useGet("/web/findStudyById/".concat(id)));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _newsApi.apply(this, arguments);
}
export function hotNewsApi(_x3) {
  return _hotNewsApi.apply(this, arguments);
}
function _hotNewsApi() {
  _hotNewsApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(param) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", usePost('/web/studyLists', param));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _hotNewsApi.apply(this, arguments);
}